import { useState } from 'react';

/** The MCP URL with a button that copies it. */
export function CopyUrl({ url }: { url: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard not available: the URL is visible and selectable anyway.
    }
  };

  return (
    <div className="flex items-stretch overflow-hidden rounded-xl border border-gray-200 bg-white">
      <code className="flex-1 select-all overflow-x-auto whitespace-nowrap px-4 py-3 font-mono text-sm text-gray-800">{url}</code>
      <button
        type="button"
        onClick={copy}
        className="shrink-0 bg-gray-900 px-4 text-sm font-semibold text-white transition-colors hover:bg-gray-700"
      >
        {copied ? '¡Copiada!' : 'Copiar'}
      </button>
    </div>
  );
}
